<div class="padding flex column">
	<b class="padding-bottom-small">Image preview</b>

	@if (preview) {
		@if (type === 'image') {
			<img [src]="preview" />
		} @else if (type === 'video') {
			<video [src]="preview" controls></video>
		}
	}

	@if (!valid) {
		<div class="margin-top-small padding-small bg-orange">
			<i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
			Image aspect ratio is not valid. Please upload an image with 1:1 aspect ratio.
		</div>
	}

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="confirm()">
				<i class="fa-solid fa-upload margin-right-smallest"></i>
				Upload
			</button>
		</div>
	</div>
</div>
